export { default } from './LabOrdersModule';
